<div class="personal-details-view-container" fxLayout="column" fxLayoutGap="15px" >
  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + personalDataChangeObject?.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="personalDataChangeObject?.status?.name">
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button
      *ngIf="personalDataChangeObject?.status?.key === PERSONAL_DATA_CHANGE_STATUS_SENT_TO_IC"
      [disabled]="!(userPermissions | async).personal_data_change.write"
      (click)="changeStatusToCompleted()"
      [class.spinner]="processingRequest"
      mat-stroked-button
      color="primary">
      <mat-icon>done</mat-icon>
      <span>Potwierdź zmianę</span>
    </button>
    <button [class.spinner]="generatingDocument" [disabled]="!(userPermissions | async).personal_data_change.write" mat-stroked-button (click)="generate()"><mat-icon>content_copy</mat-icon> Wygeneruj</button>
    <button [disabled]="!(userPermissions | async).personal_data_change.delete" (click)="delete()" mat-stroked-button color="warn"><mat-icon>delete</mat-icon> <span> Usuń</span></button>
  </div>

      <div fxLayout="row" fxFlex.lt-md="100%" fxLayoutGap="15px">
        <div fxFlex="50">
          <mat-card class="partners-add-card">
              <h3>Dane OFWCA</h3>
            <app-detail header="Imię"
                        [value]="personalDataChangeObject?.ofwca.firstName"
                        [link]="['/ofwca/szczegoly', personalDataChangeObject?.ofwca.uuid]">
            </app-detail>
            <app-detail header="Nazwisko"
                        [value]="personalDataChangeObject?.ofwca.lastName"
                        [link]="['/ofwca/szczegoly', personalDataChangeObject?.ofwca.uuid]">
            </app-detail>
            <app-detail header="Numer telefonu" [value]="personalDataChangeObject?.ofwca?.phone"></app-detail>
            <app-detail header="Adres e-mail" [value]="personalDataChangeObject?.ofwca?.emails | mainContact"></app-detail>
            <app-detail header="Partner"
                        [value]="personalDataChangeObject?.ofwca?.partner?.shortName || ''"
                        [link]="personalDataChangeObject?.ofwca?.partner ? ['/partnerzy/szczegoly', personalDataChangeObject.ofwca.partner.uuid] : undefined">
            </app-detail>
            <app-detail header="Regionalny"
                        [value]="personalDataChangeObject?.ofwca?.assetsRegional?.fullName || ''">
            </app-detail>
          </mat-card>
        </div>

        <div fxFlex="50">
          <mat-card>
              <h3>Dokumenty</h3>
            <app-detail header="TU"
                        [value]="personalDataChangeObject?.insuranceCompany.name"
                        [link]="['/tu/szczegoly', personalDataChangeObject?.insuranceCompany.id]">
            </app-detail>
            <app-detail header="Data utworzenia wniosku" [value]="personalDataChangeObject?.createdAt | date: 'yyyy-MM-dd':'UTC'"></app-detail>
            <app-detail-bool header="Dostarczone dokumenty" [value]="personalDataChangeObject?.documentsDelivered"></app-detail-bool>
            <app-detail header="Data dostarczenia dokumentu" [value]="personalDataChangeObject?.dateOfDocumentDelivery | date: 'yyyy-MM-dd':'UTC'"></app-detail>
            <app-detail-bool header="Wysłane dokumenty do TU" [value]="!!personalDataChangeObject?.dateOfSendingDocumentsToIC"></app-detail-bool>
            <app-detail header="Data wysłania dokumentu do TU" [value]="personalDataChangeObject?.dateOfSendingDocumentsToIC | date: 'yyyy-MM-dd':'UTC'"></app-detail>
          </mat-card>
        </div>
      </div>
</div>
